import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const IdentityValueLabel = ({ identity, value }) => {
	const label = useMemo(() => {
		if (identity?.length > 0) {
			const foundItem = identity.find((item) => item.propertyValue === value);
			return foundItem?.displayName || value;
		}
		return value;
	}, [identity, value]);

	return <Typography sx={{ textAlign: 'center', width: '100%' }}>{label}</Typography>;
};

IdentityValueLabel.propTypes = {
	identity: PropTypes.array,
	value: PropTypes.string.isRequired,
};

export default IdentityValueLabel;
